import { getIdFromUrl } from '../getIdFromUrl'
import { getCall } from '../../../helpers/api/api'

export const getDuzenleData = async function (idLevel, endPoint, thisProp) {
    const id = getIdFromUrl(thisProp.props.history.location.pathname, idLevel)
    await thisProp.setState({ id: id })
    if (id !== undefined) {
        const getData = await getCall(`/${endPoint}/` + id)
        let data = getData.data[0]
        for (let d in data) {
            await thisProp.setState({ [d]: data[d] })
        }
    }
    await thisProp.setState({ dataCame: true })

}
